/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<JobCategory, \'id\'>, schemaOptions: { title: \'NewJobCategory\', exclude: [ \'id\' ] })
 */
export interface NewJobCategory { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    /**
     * Nombre de la categoría del puesto de trabajo.
     */
    name: string;
    /**
     * Código de la categoría del puesto de trabajo
     */
    code: string;
}

